import { ComponentUpdateTracker } from './ComponentUpdateTracker';
import { ConsoleLoggerPlugin } from './plugins/ConsoleLoggerPlugin';
import { StateManagerPlugin } from './plugins/StateManagerPlugin';

export const componentUpdateTracker = ComponentUpdateTracker.getInstance();

export {
  ComponentUpdateTracker,
  StateManagerPlugin,
  ConsoleLoggerPlugin
};
